import { useTranslation } from "react-i18next";
import {
  Box,
  HeadingStyled,
  LazyImage,
  MainHeading,
  Span,
  SpanStyled,
  TextStyled,
} from "../../styled/Elements";
import styled from "styled-components";
import { Col, Row } from "react-bootstrap";
import { AboutAr, AboutEn } from "../../styled/AllImages";
import { falHubAboutContentKeys } from "../../data/data";
import AppStoreDownloadBadges from "../../common/AppStoreDownloadBadges";
const WhyFalBio = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const renderStyledText = (text) => {
    return text.replace(
      /<color>(.*?)<\/color>/g,
      '<span style="color: var(--themeColorSecondary);">$1</span>'
    );
  };

  const title = renderStyledText(`${t("About")} ${t("falhub")}`);

  return (
    <WhyFalBioWrapper id="about">
      <Row className="align-items-center justify-content-center">
        <Col md={6} lg={5} className="about-img">
          <Box className="d-flex justify-content-center">
            <LazyImage
              src={language === "en" ? AboutEn : AboutAr}
              className="w-100"
            />
          </Box>
        </Col>
        <Col md={6} lg={7}>
          <Box className="mt-3 mt-md-0">
            <MainHeading
              lang={language}
              className="main-heading caption-sub-heading lh-1"
              color="var(--themeColor)"
              size="38.71px"
              weight="950"
              dangerouslySetInnerHTML={{ __html: title }}
            />

            <Box className="content-wrapper about-text">
              <Box>
                <ul className="about-list">
                  {falHubAboutContentKeys?.map((num) => (
                    <li key={num}>
                      <Box>
                        <Span weight="500">{t(num)}</Span>
                        &nbsp;
                        {/* <SpanStyled>
                                  {t(`faqs_answer_one_bullet_${num}_description`)}
                                </SpanStyled> */}
                      </Box>
                    </li>
                  ))}
                </ul>
              </Box>
              <AppStoreDownloadBadges variant="about" />
              {/* <SpanStyled size="20px">{t("about_section_new_para")}</SpanStyled> */}
              {/* <SpanStyled size="18px">{t("Intro")}</SpanStyled>
        <SpanStyled size="18px">{t("Smart_Platform")}</SpanStyled>
        <SpanStyled size="18px">{t("For_Seekers")}</SpanStyled>
        <SpanStyled size="18px">{t("Belief_Statement")}</SpanStyled>
        <SpanStyled size="18px">{t("Commitment")}</SpanStyled> */}
            </Box>
          </Box>
        </Col>
      </Row>
    </WhyFalBioWrapper>
  );
};

export default WhyFalBio;

// import { useTranslation } from "react-i18next";
// import { Box, HeadingStyled, MainHeading, SpanStyled } from "../../styled/Elements";
// import styled from "styled-components";

// const WhyFalBio = ({data}) => {
//   const {
//     t,
//     i18n: { language },
//   } = useTranslation();
//   const renderStyledText = (text) => {
//     return text.replace(
//       /<color>(.*?)<\/color>/g,
//       '<span style="color: var(--themeColorSecondary);">$1</span>'
//     );
//   };
//   const secureTitle = renderStyledText(t("why_falhub"));
//   return (
//     <WhyFalBioWrapper id="about">
//       <MainHeading
//         lang={language}
//         className="main-heading caption-sub-heading lh-1"
//         color="var(--themeColor)"
//         size="38.71px"
//         weight="950"
//         dangerouslySetInnerHTML={{ __html: secureTitle }}
//       />
//       <Box className="content-wrapper">
//         {data.map((item, key) => (
//           <SpanStyled
//             weight="900"
//             key={key}
//             size="1.5rem"
//             style={{
//               backgroundColor: "var(--themeColorSecondary)",
//               color: "#fff",
//               padding: "0 5px",
//             }}
//           >
//             {t(item)}
//           </SpanStyled>
//         ))}
//       </Box>
//     </WhyFalBioWrapper>
//   );
// };

// export default WhyFalBio;

const WhyFalBioWrapper = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  /* padding-top: 20px; */
  /* text-align: center; */
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
  .content-wrapper {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 0px;
    justify-content: center;
  }
  @media (max-width: 767px) {
    .main-heading {
      font-size: 24px;
    }
    .about-img {
      display: none;
    }
  }
`;
